import React, { useEffect, useState } from 'react';
import Button from './Button';
import styles from './CookieConsent.module.scss';
import { Link } from 'react-router-dom';

export const COOKIE_CONSENT_KEY = 'cookie_consent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.container}>
      <div className={styles.text}>
        Este site utiliza cookies para melhorar sua experiência. Ao continuar navegando, você concorda com os nossos{' '}
        <Link to="/politica-de-privacidade" className={styles.link} target="_blank" rel="noopener noreferrer">
          Termos e Política de Privacidade
        </Link>.
      </div>
      <Button onClick={handleAccept} className={styles.button}>
        Ok, entendi
      </Button>
    </div>
  );
};

export default CookieConsent;
